import React, { useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import { Link, useLoaderData } from "react-router-dom";
import Premium from "./Premium";
import "./detail.css";
import Pdf from 'react-to-pdf';
import { FaArrowAltCircleRight } from "react-icons/fa";

const Card = () => {
  const card = useLoaderData();
  console.log(card);

  const ref = useRef()
  // useEffect(() => {
  //     fetch
  // },[])

  return (
    <div className="body">
      <div className="ms-3 part mt-5">
        <div className="side-1 ms-5 mt-0" ref={ref}>
          {/* <h1>Let's Introduce {card.name}</h1> */}
          <h4 className="fs-5 fw-semibold text-secondary">{card.tittle}</h4>

          <h1 className="fs-1 fw-bold">{card.name}</h1>
          <div className="d-flex justify-space-around mt-5 ms-0 ">
            <Button className="bg-light text-primary border-secondary fw-normal shadow-lg ms-2 pt-2 pb-2 ps-4 pe-4">
              Duration{" "}
              <span className="fw-bold">
                {" "}
                <br /> 5 Month
              </span>
            </Button>
            <Button className="bg-light text-primary border-secondary fw-normal shadow-lg ms-3 pt-2 pb-2 ps-4 pe-4">
              Lecture{" "}
              <span className="fw-bold">
                {" "}
                <br /> 48
              </span>
            </Button>
            <Button className="bg-light text-primary border-secondary fw-normal shadow-lg ms-3 pt-2 pb-2 ps-4 pe-4">
              Projects{" "}
              <span className="fw-bold">
                {" "}
                <br /> 7+
              </span>
            </Button>
          </div>
          <p className="mt-5 ms-3 fs-5">
          {card.details}
          </p>
        </div>

        <div className="mt-3 ms-5">
          <div className="ms-5 mb-5 me-5 text-center">
            <Pdf targetRef={ref} filename='Course_Details.pdf'>
                {
                    ({toPdf})  => <Button onClick={toPdf} className="me-5 shadow-lg float-end d-block text-center p-3 fw-semibold">Download PDF</Button>
                }
            </Pdf>
          </div>

          <img
            src={card.logo}
            alt=""
            className="w-75 shadow-lg ms-5 mt-5  rounded-5"
          ></img>
        </div>
      </div>
      <div className="ms-5">
        <Link to={`/courses/${card.id}/premium`}>
          <Button className="btn btn-warning ms-5 mt-3 p-2 pe-3 ps-3 shadow-lg fw-semibold">Get Premium Access <FaArrowAltCircleRight className=""></FaArrowAltCircleRight> </Button>
        </Link>
      </div>
    </div>
  );
};

export default Card;
